export function isPillNode(node) {
    if (!node) {
        return false;
    }
    return node.type.name === "pill";
}
/**
 * Inserts Pill node into view.
 *
 * Adds a space before node if previous node is also Pill.
 */
export function insertPillNode(view, attrs) {
    const { schema, tr, selection } = view.state;
    const pill = schema.nodes.pill.create(attrs);
    let insertPosition = selection.from;
    if (isPillNode(selection.$anchor.nodeBefore)) {
        tr.insertText(" ");
        insertPosition += 1;
    }
    tr.insert(insertPosition, pill);
    view.dispatch(tr);
    view.focus();
}
